var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import AlertTriangleSVG from './alert-triangle.icon.svg';
export const AlertTriangleIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: AlertTriangleSVG }));
_react_refresh_temp_1 = AlertTriangleIcon;
$RefreshReg$(_react_refresh_temp_1, "AlertTriangleIcon");
